import styled from "styled-components";
import { Inter_12_600 } from "../../styles/text";
import { ReactComponent as CheckIcon } from "../icons/check.svg";
import { ReactComponent as TimerIcon } from "../icons/timer.svg";
import { ReactComponent as CrossIcon } from "../icons/cross.svg";
import TooltipOrigin from "../tooltip";

const Badge = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 4px 8px;
  border-radius: 4px;
  ${Inter_12_600};

  ${(props) => {
    switch (props.status) {
      case "emitted":
        return `
          background-color: rgba(255, 152, 0, 0.1);
          color: #FF9800;
        `;
      case "accepted":
        return `
          background-color: rgba(76, 175, 80, 0.1);
          color: #4CAF50;
        `;
      case "rejected":
        return `
          background-color: rgba(244, 67, 54, 0.1);
          color: #f44336;
        `;
      case "final":
        return `
          background-color: rgba(33, 150, 243, 0.1);
          color: #2196F3;
        `;
      default:
        return `
          background-color: rgba(158, 158, 158, 0.1);
          color: #9e9e9e;
        `;
    }
  }}

  svg {
    width: 12px;
    height: 12px;

    path {
      fill: currentColor;
    }
  }
`;

const Tooltip = styled(TooltipOrigin)`
  display: inline-block;
`;

const statusLabels = {
  emitted: "Pending Validation",
  accepted: "Validated by droppBCB",
  rejected: "Rejected by droppBCB",
  final: "Finalized",
  none: "No Checkpoint",
};

const statusIcons = {
  emitted: <TimerIcon />,
  accepted: <CheckIcon />,
  rejected: <CrossIcon />,
  final: <CheckIcon />,
};

const statusTooltips = {
  emitted:
    "This checkpoint has been created and is awaiting validation by droppBCB validators",
  accepted:
    "This checkpoint has been cryptographically validated and accepted by the droppBCB validator network",
  rejected:
    "This checkpoint was rejected by droppBCB validators due to validation failure",
  final: "This checkpoint has been finalized after the challenge window period",
  none: "This block does not have a checkpoint",
};

export default function CheckpointStatusBadge({ status, showLabel = true }) {
  if (!status || status === "none") {
    return null;
  }

  const label = statusLabels[status] || status;
  const icon = statusIcons[status];
  const tooltip = statusTooltips[status] || label;

  return (
    <Tooltip tip={tooltip}>
      <Badge status={status}>
        {icon}
        {showLabel && <span>{label}</span>}
      </Badge>
    </Tooltip>
  );
}
